import React from 'react';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="GenericPage">
      <h1>{t('pages.404.title')}</h1>
      <p>{t('pages.404.body')}</p>
      <div className="GenericPage__links">
        <Button primary href={t('pages.404.primary_button.url')} className="icon-after icon-arrow-right icon-variant-1">{t('pages.404.primary_button.link')}</Button>
        <Button href={t('pages.404.secondary_button.url')} className="Button Button--secondary icon-after icon-arrow-right icon-variant-2">{t('pages.404.secondary_button.link')}</Button>
      </div>
    </div>
  );
};

export default NotFound;
